var styles = {
  "fullWidth": "pb-AddAnother__fullWidth",
  "addInfoSlotPadding": "pb-AddAnother__addInfoSlotPadding",
  "removeContainer": "pb-AddAnother__removeContainer",
  "removeContainer--hidden": "pb-AddAnother__removeContainer--hidden",
  "removeContainer-enter-active": "pb-AddAnother__removeContainer-enter-active",
  "removeContainer-exit-active": "pb-AddAnother__removeContainer-exit-active",
  "removeContainer-enter": "pb-AddAnother__removeContainer-enter",
  "removeContainer-exit": "pb-AddAnother__removeContainer-exit",
  "removeContainerSpacer": "pb-AddAnother__removeContainerSpacer",
  "item": "pb-AddAnother__item",
  "itemWrapper": "pb-AddAnother__itemWrapper",
  "itemInner": "pb-AddAnother__itemInner"
};
export default styles;